import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import styles from "./FloatingSidebar.module.scss";

const SidebarSubNavItem = ({ item, isActive, onSelect }) => {
  if (!item) return null;

  const IconComponent = item.icon;

  const handleClick = () => {
    if (!onSelect) return;
    onSelect(item);
  };

  return (
    <ListItemButton
      disableRipple
      aria-selected={isActive}
      onClick={handleClick}
      className={`${styles.navSubItem} ${isActive ? styles.navSubItemActive : ""}`}
    >
      <ListItemIcon className={styles.navSubItemIcon}>
        {IconComponent ? (
          <IconComponent fontSize="inherit" />
        ) : (
          <span className={styles.navSubItemDot} aria-hidden="true" />
        )}
      </ListItemIcon>
      <ListItemText
        primary={item.label}
        slotProps={{ primary: { className: styles.navSubItemLabel } }}
      />
    </ListItemButton>
  );
};

export default SidebarSubNavItem;
